const fallbackFormatter = (money) => {
    return `${money.value}${money.currency}`;
};
let currencyFormatter = fallbackFormatter;
export const setCurrencyFormatter = (value) => {
    currencyFormatter = value;
};
export const formatCurrency = (money) => {
    if (!money.currency) {
        return `${money.value}`;
    }
    return currencyFormatter(money);
};
export const isCustomCurrencyFormatterInitialised = () => {
    return currencyFormatter !== fallbackFormatter;
};
//# sourceMappingURL=currencyFormatter.js.map